export const SCREEN_SIZES = {
  xs: "768px",
  sm: "767px",
  md: "991px",
  lg: "1199px"
}